import { useTranslation } from 'next-i18next';
import { useMemo } from 'react';

const useRules = () => {
    const { t } = useTranslation();

    return useMemo(
        () => [
            {
                regexp: /.{8}/,
                msg: t('password_rule_char'),
            },
            {
                regexp: /[a-zA-Z]/,
                msg: t('password_rule_letter'),
            },
            {
                regexp: /[0-9]/,
                msg: t('password_rule_num'),
            },
        ],
        []
    );
};

export default useRules;
